export default __webpack_public_path__ + "static/media/widget-type-bar.4a708dca.svg";